import Insights from "./index";

const InsightsRoutes = [
  {
    component: Insights,
    path: "/insights",
    exact: true,
    type: "private",
  },
];

export default InsightsRoutes;
